module.exports = "/_next/static/images/cn-3a5b5ac1ac98c76572f65c1ddd6dcadf.svg";